import { render, staticRenderFns } from "./spotcheck.vue?vue&type=template&id=1bf17d98&scoped=true"
import script from "./spotcheck.vue?vue&type=script&lang=js"
export * from "./spotcheck.vue?vue&type=script&lang=js"
import style0 from "./spotcheck.vue?vue&type=style&index=0&id=1bf17d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf17d98",
  null
  
)

export default component.exports